<template>
	<div>

		<form method="POST" :action="action" @submit.prevent="onSubmit">
			<div class="columns is-mobile is-vcentered is-gapless is-centered reset-container">
				<div class="column is-2-desktop is-3-tablet is-hidden-mobile">
					<div class="has-background-warning radius-lg card p20 height-500">
						

					</div>
				</div>
				<div class="column is-6-desktop is-8-tablet is-11-mobile form-container">
					<div class="has-background-white card p20">
						<h3 class="has-text-weight-bold has-text-primary has-text-centered is-size-6 mb30">{{t('reset_password')}}</h3>
						<div class="pr30 pl30 mt100">
							<div class="field mb30">
								<div class="control">
                                    <input id="email" name="email" class="input line-input is-primary has-text-centered" required autocomplete="email" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" :placeholder="t('email')">
                                    <div v-show="errors.has('email')" class="help is-danger has-text-right">{{ errors.first('email') }}</div>
                                </div>
                            </div>
                            <div class="field mt90">
                            	<div class="control has-text-centered">
                            		<button type="submit" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded pr20 pl20">
                                       {{ t('Reset Link') }}
                                    </button>
                            	</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import axios from 'axios';
import trans from '../translation/user.json';
import { Validator , mapFields} from 'vee-validate';
import arabic from 'vee-validate/dist/locale/ar';
export default {
	name: 'Reset',
	props: {
		action: {
			type: String,
			required: true
		},
		sitelocale:{
			type: String,
			required: true
		},
	},
	data(){
		return{
			form : {
				email:'',
			},
			isDisabled:false
		}
	},
	mounted(){
		this.$translate.setLang(this.sitelocale);
	},
	locales: trans,
	created(){
		this.$validator.localize('ar', {
			messages: arabic.messages,
			attributes: trans.ar,
			custom:trans.ar.custom
		});
		this.$validator.localize('en', {
			custom:trans.en.custom
		});

		Validator.localize(this.sitelocale);
	},
	methods:{
		onSubmit(){
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isDisabled=true
					const action = this.action;
					axios.post(action, this.form)
					.then(response => {
						this.showAlert('success' , `${this.$translate.text('login_successfully')}`  , `${this.$translate.text('welcome')}`+response.data.data.name , '')
						setTimeout(()=>{
							window.location.href = `/${this.sitelocale}/`;
						}, 2000);

					})
					.catch(error => {
						this.showAlert('error',
							`${this.$translate.text('error_in_data')}`,
							'text',
							`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error[0]}</li>`).join(' ')+`</ul>`
							)
						this.isDisabled=false;
						console.clear();
					})
					.then(()=>{

						setTimeout(()=>{

						}, 3500);
					});

				}

			});

		},
		showAlert(type , title , text , html){
			this.$swal({
				type: type,
				title: title,
				text: text,
				html: html,
				showConfirmButton: false,
				timer:2000,
				customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
				backdrop: `
				rgba(36, 140, 204, 0.5)
				`
			});
		}
	}

};
</script>

<style lang="scss">

</style>